<template>
  <div class="course container"
    :class="getSerialPrefixCssClass">
    <course-block-with-top-menu></course-block-with-top-menu>
    <div id="stage-top"></div>
    <course-introduce id="courseIntroduce"></course-introduce>
  </div>
</template>
<script>
  import $ from 'jquery'
  import Vue from 'vue'
  import Components from '../components';
  import {
    mapGetters, mapState,
  } from 'vuex'

  import { globalMixin, platformMixin, courseMixin } from '../components/_Mixins'

  const { detect } = require('detect-browser')

  export default {
    data() {
      return {
        // series_id: this.$route.params.series_id,
        // course_id: this.$route.params.course_id,
        //course: null,
      }
    },

    mounted() {
      // console.log('Course.vue', 'mounted !!')

      let browser = detect()
    },

    // created() {
    //   // console.log('created !!')

    // },

    components: {
      CourseBlockWithTopMenu: Components.VueCourseBlockWithTopMenu,
      CourseIntroduce: Components.VueCourseIntroduce,
    },

    mixins: [ globalMixin, platformMixin, courseMixin ],

    methods: {

      // getCourse() {
      //   this.course = this.getCourseById(this.series_id, this.course_id)

      //   return this.course
      // },

      updateBodyColor() {
        let body = document.querySelector("body")

        document.querySelector("body").style.backgroundColor =
          this.body_background_color

        setTimeout(() => {
          $('.week_container .header').css('background-color', this.body_background_color)
        }, 1000)

        document.querySelector("body").className = ''
        document.querySelector("body").classList.add('course')
        // document.querySelector("body").classList.add(browser.name)

        let css_class = this.getCourseCssClass

        if (css_class) {
          if (css_class != '') {
            document.querySelector("body").classList.add(css_class)
          }
        }
      }
    },

    computed: {
      ...mapState([ 'seriesesInState' ]),
      ...mapGetters([ 'Serieses' ]),

      serieses() {
        let _serieses = this.Serieses

        return this.prepareSerieses(_serieses)
      },

      getSerialPrefixCssClass() {
        return this.series_prefix.toLowerCase()
      },

      getCourseCssClass() {
        let course = this.course == null ?
          this.getCourse() :
          this.course

        if (this.course == null) return ''

        if (this.course['css_class']) {
          return this.course.css_class
        }

        return ''
      },

      getTextColor() {
        let course = this.course == null ?
          this.getCourse() :
          this.course

        if (this.course == null) return '#ffffff'

        if (this.course['colors']) {
          if (this.course.colors['text']) {
            return this.course.colors.text
          }
        }

        return '#ffffff'
      },

      body_background_color() {
        let course = this.course == null ?
          this.getCourse() :
          this.course

        console.log('Course.vue > body_background_color() > course : ', course)

        if (this.course == null) return '#ffffff'

        if (this.course['colors']) {
          if (this.course.colors['main']) {
            return this.course.colors.main
          }
        }

        //return course.main_color
        return '#ffffff'
      }

    },

    watch: {
      '$route': function (to, from) {
        //console.log('watch', to, from, to.path, this.$router)
        this.$router.go({
          path: to.path,
          force: true,
        })
      },

      // getCurrentCourse: function(value) {
      //   console.log('Course.vue > watch > getCurrentCourse : ', value)

      //   this.updateBodyColor()
      // },

      // getCourseIdReady: function(value) {
      //   console.log('Course.vue > watch > getCourseIdReady : ', value)
      // },

      course: function(value) {
        if (value) {
          console.log('Course.vue > watch > course : ', value)

          this.updateBodyColor()
        }
      }

    },

    // beforeRouteEnter (to, from, next) {
    //   console.log('beforeRouteEnter', to, from)
    //   next()
    // },

    // beforeRouteUpdate (to, from, next) {
    //   console.log('beforeRouteUpdate', to, from, this.$router)
    //   this.name = to.params.name
    //   next()
    // },

    // beforeRouteLeave (to, from, next) {
    //   console.log('>>> Course beforeRouteLeave', this, to, from)
    //   next(false)
    // },
  }

</script>



// WEBPACK FOOTER //
// src/views/Course.vue